import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceTongueIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.5 13.5C9.5 14.3284 8.82843 15 8 15C7.17157 15 6.5 14.3284 6.5 13.5V11C6.5 10.4477 6.94772 10 7.5 10H8.5C9.05229 10 9.5 10.4477 9.5 11V13.5Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.60001 9H11.4L11.4556 9.00006L11.4869 9.00031C11.5063 9.00055 11.5227 9.00104 11.5372 9.00195C11.5526 9.00287 11.5658 9.00421 11.5782 9.00616C11.7922 9.04004 11.96 9.20782 11.9938 9.42175C12 9.46063 12 9.50708 12 9.59998C12 9.97162 12 10.1574 11.9754 10.3129C11.8499 11.1052 11.2652 11.7393 10.5 11.9366V13.5C10.5 13.91 10.4013 14.2971 10.2263 14.6385C13.0008 13.7084 15 11.0876 15 8C15 4.13403 11.866 1 8 1C4.134 1 1 4.13403 1 8C1 11.0876 2.99918 13.7084 5.77371 14.6385C5.59872 14.2971 5.5 13.9101 5.5 13.5V11.9366C4.7348 11.7393 4.15012 11.1052 4.02463 10.3129C4 10.1574 4 9.97162 4 9.59998C4 9.50708 4 9.46063 4.00616 9.42175C4.04004 9.20782 4.20782 9.04004 4.42178 9.00616C4.46066 9 4.50711 9 4.60001 9ZM9.16458 4.07916C8.7941 4.2644 8.64395 4.7149 8.82919 5.08539C9.0759 5.5788 9.35617 6.11035 9.97708 6.42078C10.5323 6.69843 11.2689 6.75 12.25 6.75C12.6642 6.75 13 6.41418 13 6C13 5.58575 12.6642 5.25 12.25 5.25C11.2311 5.25 10.8427 5.17651 10.6479 5.07916C10.5188 5.01465 10.4241 4.92114 10.1708 4.41455C9.98557 4.04407 9.53506 3.89392 9.16458 4.07916ZM7.17081 5.08539C7.35605 4.7149 7.2059 4.2644 6.83542 4.07916C6.46494 3.89392 6.01443 4.04407 5.82919 4.41455C5.5759 4.92114 5.48117 5.01465 5.35208 5.07916C5.15735 5.17651 4.76889 5.25 3.75 5.25C3.33578 5.25 3 5.58575 3 6C3 6.41418 3.33578 6.75 3.75 6.75C4.73111 6.75 5.46765 6.69843 6.02292 6.42078C6.64383 6.11035 6.9241 5.5788 7.17081 5.08539Z"
		/>
	</svg>
))
